export interface MaintenanceModeWeb {
    enabled: boolean;
    message: string;
}

export const GLOBALS_COLLECTION_IN_FIRESTORE = "globals";
export const MAINTENANCE_MODE_WEB_DOCUMENT_IN_FIRESTORE = "MaintenanceModeWeb";
